import React from 'react';

/**
 * tabs: [{ key, label }]
 * value: active key, onChange(key)
 */
export default function Tabs({ tabs, value, onChange }) {
  return (
    <div className="mb-4 border-b border-gray-200">
      <nav className="-mb-px flex gap-1">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              value === t.key
                ? 'border-brand text-brand'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
